import TechTableRow from './rows/TechTableRow'
import styles from './styles.module.css'
import TechTableHeader from './table-headers/TechTableHeader'
import useFetch from '../../../../global/hooks/useFetchHook'
import { getAllSchedules } from '../../api'
import CircularProgress from '@mui/material/CircularProgress'
import { WoDetailContextProvider } from '../../../../work-orders/components/context/context'
import { IScheduleFilter } from '../../main/ScheduleMain'
import { IRoute } from '../../../../../../app/entities/Route'

export default function TechTableContainer(props: IScheduleFilter) {
  const { scheduleFilter } = props

  const {
    data: routes,
    isLoading,
    refetch,
  } = useFetch<IRoute[]>(
    getAllSchedules(scheduleFilter.date, scheduleFilter.locationObjectId),
  )

  function renderTechnicianRoutes(routes: IRoute[]) {
    const sortedRoutes = routes
      .filter((route: IRoute) => !!route.location)
      .sort((a: IRoute, b: IRoute) => {
        const { stateAbbr: stateA, name: displayNameA } = a.location!
        const { stateAbbr: stateB, name: displayNameB } = b.location!

        const displayNameCompare = displayNameA.localeCompare(displayNameB)
        const stateAbbrCompare = stateA.localeCompare(stateB)

        return displayNameCompare || stateAbbrCompare
      })

    return sortedRoutes.map((route: IRoute, index: number) => (
      <TechTableRow
        key={route.objectId || `route-${index}`}
        route={route}
        techAvatarUri={route.technician?.profilePicture}
        date={scheduleFilter.date}
        refetch={refetch}
      />
    ))
  }

  return (
    <WoDetailContextProvider>
      <div className={styles.tableContainer}>
        {isLoading ? (
          <div className={styles.progressContainer}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {routes && routes.length > 0 ? (
              <>
                <TechTableHeader />
                {renderTechnicianRoutes(routes)}
              </>
            ) : (
              <>
                <div className={styles.progressContainer}>NO RECORDS FOUND</div>
              </>
            )}
          </>
        )}
      </div>
    </WoDetailContextProvider>
  )
}
